import React, { useState, useEffect } from "react";
import { busApi } from "../../services/api/busApi";

function LinhasOnibus({ onLinhaSelect }) {
  const [linhas, setLinhas] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState("");

  useEffect(() => {
    const fetchLinhas = async () => {
      setLoading(true);
      try {
        const response = await busApi.getRoutes(searchTerm);
        setLinhas(response.data);
      } catch (error) {
        console.error("Erro ao buscar linhas:", { error, searchTerm });
      } finally {
        setLoading(false);
      }
    };

    const delayDebounceFn = setTimeout(() => fetchLinhas(), 500);
    return () => clearTimeout(delayDebounceFn);
  }, [searchTerm]);

  return (
    <div className="sheet-linhas-container">
      <h2>Linhas de Ônibus</h2>
      <input
        type="text"
        placeholder="Buscar linha (ex: 2109)"
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
        className="search-input"
      />

      {loading ? (
        <p style={{ textAlign: 'center', padding: '20px', color: '#6b7280' }}>
          Carregando...
        </p>
      ) : (
        <ul className="linhas-list">
          {linhas.length > 0 ? (
            linhas.map((linha) => (
              <li
                key={linha.routeId}
                onClick={() => onLinhaSelect && onLinhaSelect(linha)}
              >
                <span
                  className="linha-cor"
                  style={{ backgroundColor: linha.color }}
                ></span>
                <strong>{linha.shortName}</strong> - {linha.longName}
              </li>
            ))
          ) : (
            <p style={{ textAlign: 'center', padding: '20px', color: '#6b7280' }}>
              Nenhuma linha encontrada.
            </p>
          )}
        </ul>
      )}
    </div>
  );
}

export default LinhasOnibus;
